import React from 'react';

const Logo = ({ className = "", size = "default" }) => {
  const sizeClasses = {
    small: "h-20",
    default: "h-24", 
    large: "h-32"
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Sport Psychology Logo */}
      <div className={`${sizeClasses[size]} flex-shrink-0`}>
        <img 
          src="https://customer-assets.emergentagent.com/job_mindcoach-2/artifacts/t75zv7cu_Grow%20Sport%20Psychology%20Logo.svg" 
          alt="Grow Sport Psychology Logo" 
          className={`${sizeClasses[size]} w-auto object-contain`}
          style={{ filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))' }}
        />
      </div>
      
    </div>
  );
};

export default Logo;